import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { resolve } from 'api/resolve';

import { useProjectsApi } from '../projects/projects-api';
import { nodeDetailQueryKeys } from './nodeDetailQueryKeys';

/**
 * Fetch a single node's permitted property values from the permission-safe detail endpoint.
 *
 * The backend projects only the properties the caller is allowed to see (driven by the
 * user-specific template), so this replaces the legacy `:graph` endpoint which returned the
 * raw, unfiltered property bag.
 *
 * `placeholderData: keepPreviousData` keeps the last node's payload on screen while the next
 * node's query is in flight, so the details panel shell does not swap to a spinner on every
 * selection change (the grid panel already behaves this way via GRID_STORE).
 */
export function useNodeDetail(
  projectId: string,
  templateNodeId: string,
  dataNodeId: string,
  proposalId?: string,
  enabled = true
) {
  const { getNodeDetail } = useProjectsApi();

  return useQuery({
    queryKey: nodeDetailQueryKeys.detail(projectId, dataNodeId, proposalId, templateNodeId),
    queryFn: () => resolve(getNodeDetail(projectId, templateNodeId, dataNodeId, proposalId)),
    enabled: enabled && !!projectId && !!templateNodeId && !!dataNodeId,
    placeholderData: keepPreviousData
  });
}
